import React from 'react'
import {ISuggestedCreative} from '../types/types'

interface SuggestedCreativesPanelProps {
    creatives: ISuggestedCreative[]
    selectedIds: Set<string>
    onToggle: (creative: ISuggestedCreative) => void
}

const SuggestedCreativesPanel = ({creatives, selectedIds, onToggle}: SuggestedCreativesPanelProps) => {
    if (creatives.length === 0) {
        return (
            <aside className="suggested-panel">
                <h3 className="suggested-panel__title">Креативы приложения</h3>
                <p className="suggested-panel__empty">По этому приложению нет неподанных креативов</p>
            </aside>
        )
    }

    return (
        <aside className="suggested-panel">
            <h3 className="suggested-panel__title">Креативы приложения</h3>
            <ul className="suggested-panel__list">
                {creatives.map((c) => {
                    const isSelected = selectedIds.has(c.creative_external_id)
                    return (
                        <li
                            key={c.creative_external_id}
                            className={`suggested-panel__item${isSelected ? ' suggested-panel__item--selected' : ''}`}
                            onClick={() => onToggle(c)}
                        >
                            <span className="suggested-panel__mark" aria-hidden>{isSelected ? '✓' : ''}</span>
                            <span className="suggested-panel__name">
                                {c.erid ? `${c.erid} — ${c.creative_external_name}` : c.creative_external_name}
                            </span>
                        </li>
                    )
                })}
            </ul>
        </aside>
    )
}

export default React.memo(SuggestedCreativesPanel)
